import React from 'react';
import RateTypesForm from './RateTypesForm'; // Correct path
import { useParams } from 'react-router-dom';

const EditRateTypePage = () => {
    const { id } = useParams();
    // Render only if ID is present, otherwise show loading or redirect
    return id ? <RateTypesForm formType="edit" currentRateTypeId={id} /> : <div>Loading...</div>;
};

export default EditRateTypePage;